export default __webpack_public_path__ + "static/media/19thAnnualLectureTab.f3134004.png";